import { OccasionPage } from "@/components/public/OccasionPage"
import labelClub from "@/images/label-club.webp"

const DESCRIPTION =
  "Private label wine for restaurants, hotels and members' clubs: house wines and Cap Classique with your own label, delivered throughout the UK."

export default function Hospitality() {
  return (
    <OccasionPage
      title="Hospitality"
      metaTitle="Private Label Wine for Hospitality"
      description={DESCRIPTION}
      lede="House wines and Cap Classique labelled for your restaurant, hotel or members' club."
      heroImage={{
        src: labelClub,
        alt: "Bespoke house wine label for a members' club",
        width: 936,
        height: 1681,
      }}
      story={{
        eyebrow: "Hospitality",
        heading: "Your own house wine",
        paragraphs: [
          "For restaurants, hotels and members' clubs, a house wine with your own label turns something ordinary into part of the experience — poured by the glass, listed on the wine list, or offered as a welcome bottle in every room.",
          "We help you choose a wine, red, white, rosé or MCC, at a price point that works across your list, then design a label built for repeat ordering rather than a one-off run.",
        ],
      }}
      cellar={{
        lede: "A small selection of bespoke bottles produced for clubs, schools and clubhouses across the United Kingdom.",
        bottles: [
          {
            src: labelClub,
            alt: "Members' club commemorative bottle",
            name: "Members' Club",
            place: "London",
          },
        ],
      }}
    />
  )
}
